import { ProductType } from '@brand-console/types'

export interface LeftNavProps {
  open: boolean
  product?: ProductType
}
